import { lmsReportType } from "../constants/lmsReportType";

export const getLmsReport = (data) => ({
  type: lmsReportType.GET_LMS_REPORT_PENDING,
  data,
});

export const lmsReportSuccess = (data) => ({
  type: lmsReportType.GET_LMS_REPORT_SUCCESS,
  data,
});

export const lmsReportFailure = (error) => ({
  type: lmsReportType.GET_LMS_REPORT_FAILURE,
  error,
});

export const getLmsReportCourse = (data) => ({
  type: lmsReportType.GET_LMS_REPORT_COURSE_PENDING,
  data,
});

export const getLmsReportCourseSuccess = (data) => ({
  type: lmsReportType.GET_LMS_REPORT_COURSE_SUCCESS,
  data,
});

export const getLmsReportCourseFailure = (error) => ({
  type: lmsReportType.GET_LMS_REPORT_COURSE_FAILURE,
  error,
});

export const getLmsReportLesson = (data) => ({
  type: lmsReportType.GET_LMS_REPORT_LESSON_PENDING,
  data,
});

export const getLmsReportLessonSuccess = (data) => ({
  type: lmsReportType.GET_LMS_REPORT_LESSON_SUCCESS,
  data,
});

export const getLmsReportLessonFailure = (error) => ({
  type: lmsReportType.GET_LMS_REPORT_LESSON_FAILURE,
  error,
});

export const getLmsDashboardReport = (data) => ({
  type: lmsReportType.GET_LMS_DASHBOARD_REPORT_PENDING,
  data,
});

export const getLmsDashboardReportSuccess = (data) => ({
  type: lmsReportType.GET_LMS_DASHBOARD_REPORT_SUCCESS,
  data,
});

export const getLmsDashboardReportFailure = (error) => ({
  type: lmsReportType.GET_LMS_DASHBOARD_REPORT_FAILURE,
  error,
});

export const getLmsDashboardReportDetails = (data) => ({
  type: lmsReportType.GET_LMS_DASHBOARD_REPORT_DETAILS_PENDING,
  data,
});

export const getLmsDashboardReportDetailsSuccess = (data) => ({
  type: lmsReportType.GET_LMS_DASHBOARD_REPORT_DETAILS_SUCCESS,
  data,
});

export const getLmsDashboardReportDetailsFailure = (error) => ({
  type: lmsReportType.GET_LMS_DASHBOARD_REPORT_DETAILS_FAILURE,
  error,
});

export const clearDashboardDetails = (data) => ({
  type: lmsReportType.CLEAR_LMS_DASHBOARD_REPORT_DETAILS,
  data,
});
// courseLessonSafety meeting complete
export const getCourseLessonSafetyMeetingComplete = (data) => ({
  type: lmsReportType.GET_LMS_DASHBOARD_COURSE_LESSON_SAFETYMETTING_COMPLETED_PENDING,
  data,
});

export const getCourseLessonSafetyMeetingCompleteSuccess = (data) => ({
  type: lmsReportType.GET_LMS_DASHBOARD_COURSE_LESSON_SAFETYMETTING_COMPLETED_SUCCESS,
  data,
});

export const getCourseLessonSafetyMeetingCompleteFailure = (error) => ({
  type: lmsReportType.GET_LMS_DASHBOARD_COURSE_LESSON_SAFETYMETTING_COMPLETED_FAILURE,
  error,
});

export const clearCourseLessonSafetyMeetingComplete = (data) => ({
  type: lmsReportType.CLEAR_LMS_DASHBOARD_REPORT_LESSON_COURSE_SAFETY_COMPLETED,
  data,
});

// courseLessonSafety meeting Incomplete
export const getCourseLessonSafetyMeetingInComplete = (data) => ({
  type: lmsReportType.GET_LMS_DASHBOARD_COURSE_LESSON_SAFETYMETTING_INCOMPLETED_PENDING,
  data,
});

export const getCourseLessonSafetyMeetingInCompleteSuccess = (data) => ({
  type: lmsReportType.GET_LMS_DASHBOARD_COURSE_LESSON_SAFETYMETTING_INCOMPLETED_SUCCESS,
  data,
});

export const getCourseLessonSafetyMeetingInCompleteFailure = (error) => ({
  type: lmsReportType.GET_LMS_DASHBOARD_COURSE_LESSON_SAFETYMETTING_INCOMPLETED_FAILURE,
  error,
});
export const clearCourseLessonSafetyMeetingInComplete = (data) => ({
  type: lmsReportType.CLEAR_LMS_DASHBOARD_REPORT_LESSON_COURSE_SAFETY_INCOMPLETED,
  data,
});
export const getLmsScormCourseReport = (data) => ({
  type: lmsReportType.GET_LMS_SCORMLIST_REPORT_PENDING,
  data,
});

export const getLmsScormCourseSuccess = (data) => ({
  type: lmsReportType.GET_LMS_SCORMLIST_REPORT_SUCCESS,
  data,
});

export const getLmsScormCourseFailure = (error) => ({
  type: lmsReportType.GET_LMS_SCORMLIST_REPORT_FAILURE,
  error,
});
export const ClearscormCourseList = () => ({
  type: lmsReportType.CLEAR_LMS_DASHBOARD_GET_LMS_SCORMLIST_REPORT,
  data: "",
});
export const getLmsReportScormEmailSuccess = () => ({
  type: lmsReportType.GET_LMS_SCORM_REPORT_LIST_EMAIL_SUCCESS,
});
